module.exports = __webpack_public_path__ + "static/b6-d47e177ac3dee82c0ea21fb024a437b4.jpg";